const PERMISSION_KEY= "personalize:nebula_decisions";
const PAGE_URL = {
    NEBULA_DECISIONS_PAGE: "/admin/personalize/nebula-decisions"
}

export {PERMISSION_KEY, PAGE_URL}

